module.exports = __webpack_public_path__ + "img/00039.0853621e.webp";